import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import EventsReportList from './list';
import EventsReportDetails from './details';

class EventsReport extends Component {
    render() {
        return (
            <Switch>
                <Route path={`${this.props.match.url}/:id`} component={EventsReportDetails} />
                <Route path={`${this.props.match.url}`} component={EventsReportList} />
            </Switch>
        );
    }
}

export default EventsReport;
